export const setProfileData = (data) => {
    return {
        type: 'setProfileData',
        payload: data
    }
}

export const setInfoData = (data) => {
    return {
        type: 'setInfoData',
        payload: data
    }
}